var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSendWithBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.332 27.435c-.243.47-.822.77-1.42.397l-4.233-2.645c-1.128-.705-.07-2.398 1.058-1.693l2.741 1.713-.514-14.694-13.432 5.98 2.74 1.712c1.13.705.071 2.398-1.057 1.693l-4.232-2.645c-.599-.374-.583-1.025-.267-1.45.1-.196.266-.36.483-.458l16.305-7.258a.998.998 0 0 1 1.403.877l.624 17.837a.994.994 0 0 1-.2.634zM20.59 16.194l-3.192 5.108c-.705 1.128-2.398.07-1.693-1.058l3.192-5.108c.705-1.129 2.398-.07 1.693 1.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M18 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18-8.059 18-18 18zm0-1.846c8.922 0 16.154-7.232 16.154-16.154S26.922 1.846 18 1.846 1.846 9.078 1.846 18 9.078 34.154 18 34.154z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendWithBorder);
export default __webpack_public_path__ + "static/media/icon-send-with-border.85492f372ebe2c072776de935e724a85.svg";
export { ForwardRef as ReactComponent };